import { MessageProps } from "@hightouch/formkit";
import { Alert } from "@hightouch/htui";
import { Markdown } from "src/ui/markdown";

export const FKMessage = ({ message, variant, title }: MessageProps) => {
  let titleToUse = title || "Information";
  if (variant && variant !== "subtle") {
    const firstLetter = variant.charAt(0).toUpperCase();
    const remainingLetters = variant.slice(1);
    titleToUse = firstLetter + remainingLetters;
  }
  return (
    <Alert
      variant="inline"
      type={variant ?? "info"}
      title={titleToUse}
      message={message && <Markdown>{message}</Markdown>}
    />
  );
};
